export enum GameState {
    WaitBurn = 2,
    WaitDragonCard,
    WaitTigerCard,

    DragonWin = 0x7000,
    TigerWin,
    Draw,
}
